// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__22vd2","itemTitle":"ClientEmergencyInfo_itemTitle__T2Mem","itemText":"ClientEmergencyInfo_itemText__1NWqb"};